export default {
    moduleId: "Flow.Html.ModuleId",
    systemInfoModuleId: "WE.SystemInformation",
    flowId: "flow",
    moduleName: "Flow",
    moduleKeyName: "FlowLog",
    writeLogUrl: "api/Log/WriteLog/",
    selectedContainerPropertyName: "_containerId",
    partialUrls: {
        clearSelectedProduct: "api/Workspace/ClearSelectedProduct",
        enterSingleModuleMode: "api/Workspace/EnterSingleModuleMode",
        exitSingleModuleMode: "api/Workspace/ExitSingleModuleMode",
        getProductConfigManifest: "api/Manifest/GetProductConfigManifest",
        getWorkspace: "api/Workspace/GetWorkspace",
        hasSelectedProduct: "api/Workspace/HasSelectedProduct",
        heartbeat: "Heartbeat",
        home: "#/Home",
        homeConfigGet: "api/HomeConfig/Get",
        homeConfigReset: "api/HomeConfig/Reset",
        homeConfigUpdate: "api/HomeConfig/Update",
        manifest: "api/Manifest",
        saveBlacklist: "api/Workspace/SaveBlacklist",
        saveSelectedProduct: "api/Workspace/SaveSelectedProduct",
        selectTheme: "api/Workspace/SelectTheme",
        validateAndSanitize: "api/Manifest/ValidateAndSanitize",
        weNotificationsWeb: "/WE.Notifications.Web/",
        whoami: "api/Workspace/WhoAmI"
    },
    componentIds: {
        information: "FlowHtml.Information",
        confirm: "FlowHtml.Confirm",
        defaultWorkingContext: "FlowHtml.DefaultWorkingContext",
        homeContext: "Home",
        error: "FlowHtml.Error",
        homeConfiguration: "FlowHtml.HomeConfiguration",
        inspector: "FlowHtml.Inspector",
        credit: "FlowHtml.Credit",
        logoutCountdownDialog: "FlowHtml.LogoutCountdownDialog",
        defaultWorkingContextFlow3: "Flow.DefaultWorkingContext",
        productSelectorDialog: "FlowHtml.ProductSelectorDialog",
        systemInformationDialog: "FlowHtml.SystemInformationDialog",
        shadowContainer: "ShadowComponent",
        loginDialog: "FlowHtml.LoginDialog"
    },
    userContextTabs: {
        moduleSelector: "FlowHtml.ModuleSelector"
    },
    elementIds: {
        homeCanvas: "#homeCanvas",
        appCanvas: "#appCanvas",
        canvas: "#lcCanvas",
        bottomNavigation: "#lcBottomNavigation",
        menu: "#lcMenu",
        workflow: "#lcWorkflow",
        dash: "#dash",
        dashFilter: "#dashFilter"
    },
    elementIdsWithoutHash: {
        dash: "dash",
        dashFilter: "dashFilter"
    },
    topics: {
        workingContextChangeStarted: "flow.workingContent.changeStarted",
        workingContextChanged: "flow.workingContent.changed",
        componentViewChanged: "flow.contextView.changed",
        workingContextViewExpandedChanged: "flow.workingContext.expandedChanged",
        viewPortChanged: "flow.viewPort.changed",
        resizeComponent: "flow.viewPort.resizeComponent",
        loggingOut: "flow.userContext.logout",
        roleChanged: "flow.userContext.roleChanged",
        resizeSingleComponent: "flow.viewPort.resizeSingleComponent",
        menuChanged: "flow.menu.changed",
        routeChanged: "flow.router.routechanged",
        routeWillChange: "flow.router.routewillchange",
        componentAddedMobileMode: "flow.componentAddedMobileMode",
        navigationPanelItemSelected: "flow.navigationPanelItemSelected",
        hideMenu: "flow.menu.hide",
        containerTitleChanged: "flow.container.titleChanged",
        componentActivated: "flow.componentActivated",
        sideTabExpandedChanged: "flow.sideTab.expandedChanged",
        environmentPrefix: "environment.",
        mobileMenuHide: "flow.mobileMenu.hide",
        mobileMenuShow: "flow.mobileMenu.show",
        homescreenRequestUpdate: "flow.homescreen.requestUpdate",
        homescreenUpdated: "flow.homescreen.updated"
    },
    inactivityTopics: {
        closeInactivityDialog: "flow.closeInactivityDialog",
        otherTabHasUnsavedData: "flow.otherTabHasUnsavedData"
    },

    storageChannelTopics: {
        timeSync: "Flow3.Inactivity.SecondsElapsed",
        logout: "Flow3.Inactivity.ForceLogout",
        reload: "Flow3.Page.ForceReload",
        unsavedData: "Flow3.Session.UnsavedData",
        systemInformationSeen: "Flow3.SystemInformation.Seen"
    },

    forceLogoutMessage: "Forced Logout",

    defaultViewModelIds: {
        workingContext: "flow/viewModels/DefaultWorkingContextViewModel",
        viewModel: "flow/viewModels/DefaultViewModel"
    },
    images: {
        home: "lc-icon-Home"
    },
    metaKeys: {
        home: "FlowHtml.Translations.NavigationPanelHome",
        notProdEnvironment: "Common.Domain.NotProdEnvironment",
        products: "FlowHtml.Products",
        productsFlow3: "Flow3Meta.Products",
        themeSelector: "FlowHtml.Settings.ThemeSelector",
        webModules: "FlowHtml.WebModules"
    },

    // Would like to get rid of these as they are not used by Flow anymore,
    // but as config was exposed in public interface I don't dare to remove then right now.
    views: {
        errorDialog:
            '<p data-bind="safeHtml: text"></p><div data-bind="visible: showDetails" class="lc-vertical-space-3"><a href="#" style="text-decoration: none; color: var(--lc-default-link-color);" data-bind="click: showHideDetails, text: detailsText, css:{ arrowDown: detailsVisible() == false, arrowUp: detailsVisible() == true}"></a><textarea rows="5" cols="60" data-bind="text: errorLog, slideDownVisible: detailsVisible"></textarea></div>',
        informationDialog: '<p data-bind="safeHtml: text"></p>',
        confirmDialog: '<p data-bind="safeHtml: text"></p>',
        buttonPane:
            '<div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" data-bind="stopBinding: true"><div class="ui-dialog-buttonset" data-bind="foreach: commands, visible: commands().length > 0"><button type="button" class="btn" data-bind="click: click, visible: isVisible, enable: isEnabled, text: text, attr: { id: commandId }, hasFocus: focusObs, css: buttonClass"></button></div></div>'
    },
    externalEventPollingInterval: 20,
    notificationTypes: {
        error: 1,
        warning: 2,
        success: 3,
        info: 4
    },
    preventImplicitFormSubmission: true,

    viewportMargin: 24,

    toastrConfig: {
        success: {
            timeOut: 5000,
            extendedTimeOut: 2000
        },
        info: {
            timeOut: 8000,
            extendedTimeOut: 8000
        },
        warning: {
            timeOut: 8000,
            extendedTimeOut: 8000
        },
        error: {
            timeOut: 8000,
            extendedTimeOut: 8000
        },
        stickySuccess: {
            timeOut: 0,
            extendedTimeOut: 0,
            closeButton: true,
            tapToDismiss: false
        },
        stickyInfo: {
            timeOut: 0,
            extendedTimeOut: 0,
            closeButton: true,
            tapToDismiss: false
        },
        stickyWarning: {
            timeOut: 0,
            extendedTimeOut: 0,
            closeButton: true,
            tapToDismiss: false
        },
        stickyError: {
            timeOut: 0,
            extendedTimeOut: 0,
            closeButton: true,
            tapToDismiss: false
        }
    },

    groupMenuType: {
        search: "Search",
        config: "Config",
        statistics: "Statistics",
        supportDocuments: "SupportDocuments",
        compilations: "Compilations",
        backgroundJobs: "BackgroundJobs"
    },

    customGroupMenuType: {
        selectPerson: "SelectPerson"
    },

    pagebreakSeparator: '<div style="page-break-after: always; clear: both"></div>',

    storageKeys: {
        selectedProduct: "FlowHtml.SelectedProduct",
        lastProduct: "FlowHtml.LastProduct",
        urlOverrides: "FlowHtml.UrlOverrides"
    },

    otherProductId: "Other",
    singleWebModuleProductId: "SingleWebModuleProduct",

    urlParams: {
        continueUrl: "continueurl",
        forceSingleModule: "forceSingleModule",
        singleModule: "singleModule"
    },

    logoutUrl: undefined,

    keyCodes: {
        ESCAPE: "Escape", //27,
        TAB: "Tab", //9,
        ENTER: "Enter", //13,
        UP: "ArrowUp", //38,
        DOWN: "ArrowDown" //40
    },

    icons: {
        add: "lc-icon-Add-large",
        eye: "lc-icon-Eye",
        logout: "lc-icon-Sign-out",
        trash: "lc-icon-Trash"
    }
};
